var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty"},[_c('b-icon-archive-fill',{attrs:{"scale":"4"}}),_c('p',{staticClass:"text"},[_vm._v("暂无数据")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }